// utils/translations.js

// מיפוי שמות שדות לעברית
export const keyTranslations = {
    id: 'ת.ז.',
    donor_id: 'ת.ז.',
    first_name: 'שם פרטי',
    last_name: 'שם משפחה',
    phone: 'טלפון',
    address: 'כתובת',
    email: 'אימייל',
    notes: 'הערות',
    referring_teacher: 'מורה מקשרת',
    comments: 'הערות',
    type_case: 'דירוג מקרה',
    teacher_phone: 'פלאפון מורה מקשרת',
    join_date: 'תאריך הצטרפות',
    status: 'סטטוס',
    createdAt: 'תאריך הצטרפות'
};

// מיפוי סטטוסים לעברית
export const statusHebrewMap = {
    active: 'פעיל',
    inactive: 'לא פעיל',
    recurring: 'חוזר'
};

// מיפוי שדות לפי סוג (donor/beneficiary)
export const allowedKeysByType = {
    donor: ['donor_id','first_name','last_name','email','phone','address','status','createdAt','comments'],
    beneficiary: ['id','first_name','last_name','email','phone','referring_teacher','join_date','address','type_case','teacher_phone','comments']
};

// פונקציה שמחזירה את הערך המתורגם של סטטוס
export const getStatusInHebrew = (status) => statusHebrewMap[status] || status;

// פונקציה שמחזירה שם שדה בעברית
export const translateKey = (key) => keyTranslations[key] || key;
